export class ValidatieVoorEenheidNummerModel {
  constructor(
    public eenheidNummer: string,
    public eenheidSoort: string,
    public eenheidAanduiding: string,
    public betrokkenWerklijn: {
      awbId: string;
      versie: number;
    } | null,
  ) {}
}

export function mapValidatieVoorEenheidNummer(
  rawModel: ValidatieVoorEenheidNummerModel,
): ValidatieVoorEenheidNummerModel {
  return new ValidatieVoorEenheidNummerModel(
    rawModel.eenheidNummer,
    rawModel.eenheidSoort,
    rawModel.eenheidAanduiding,
    rawModel.betrokkenWerklijn,
  );
}
